import { render } from "./InvoiceItemContainer.vue?vue&type=template&id=3086a738"
import script from "./InvoiceItemContainer.vue?vue&type=script&lang=js"
export * from "./InvoiceItemContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__